export default __webpack_public_path__ + "static/2-bf2a438fa14118ae9e998c95efba0c8f.jpeg";